import React, { Component } from "react";
import { ResponsivePie } from "@nivo/pie";
import { animated } from '@react-spring/web'
import { Skeleton } from "primereact/skeleton";
import Typography from "@@/components/General/Typography";
import { Column, Row } from "@selkirk-systems/layout";
import { Connect } from '@selkirk-systems/state-management';
import StatusesStore from "@@/stores/StatusesStore";
import stc from "string-to-color";


/**
 * Example data structure
 *  {
        id: "Not Contained",
        label: "Not Contained",
        value: 16,
        color:"#41B6E6"
    },
 */

class ActiveFiresByStatusGraph extends Component {

    static subscribe=[StatusesStore];

    static defaultProps = {
        padAngle:1,
        data: [
        ],
    };

    static storeStateToProps={
        data:( props,state )=>state.data
    }

    constructor(props){
        super(props);

        this.element = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {

        if(!this.element || this.element.current.style===this.element.current.clientHeight) return;


        this.element.current.style.height = `${this.element.current.clientHeight}px`;   
    }

    render() {
        const { data, style } = this.props;

        const noResults = data ? data.filter( i => i.value ).length < 1 : true;

        const graphData = data && data.map((item)=>{
            return{
                color:item.color || stc(item.value),
                label:item.value,
                id: item.value,
                value:item.count
            }
        });
       
        return (
            <div ref={this.element} className="pie-graph-wrapper" style={{...style,height:'100%',minHeight:'200px'}}>

                {data === null && (
                    <Column center>
                        <Skeleton  size="16rem" shape="circle"></Skeleton>
                    </Column>
                )}

                {data !== null && noResults &&
                    <Row justifyItems='center' xs="1fr">
                        <div className="pie-no-results">
                            <div className="circle__content"><Typography variant="h5">No Data</Typography></div>
                        </div>
                    </Row>
                }
                
                {data && !noResults && 
                        <ResponsivePie
                            data={graphData}
                            sortByValue={true}
                            innerRadius={0.4}
                            padAngle={this.props.padAngle}
                            cornerRadius={2}
                            //Uncommment this if you want color to be set by the data.
                            colors={{ datum: 'data.color' }}
                            borderColor={{
                                from: "color",
                                modifiers: [["brighter", "0.1"]],
                            }}
                            enableRadialLabels={false}
                            radialLabel={function ( e ) {
                                return e.id + " (" + e.value + ")";
                            }}
                            radialLabelsSkipAngle={10}
                            radialLabelsTextXOffset={6}
                            radialLabelsTextColor="#333333"
                            radialLabelsLinkOffset={5}
                            radialLabelsLinkDiagonalLength={16}
                            radialLabelsLinkHorizontalLength={25}
                            radialLabelsLinkStrokeWidth={6}
                            radialLabelsLinkColor={{ from: "color" }}
                            slicesLabelsSkipAngle={6}
                            slicesLabelsTextColor="#333333"
                            enableArcLinkLabels={false}
                            animate={true}
                            motionStiffness={90}
                            motionDamping={15}
                            arcLabelsSkipAngle={20}
                            arcLabelsRadiusOffset={0.55}
                            arcLabelsTextColor={{
                                from: 'color',
                                modifiers: [['darker', 0.6]],
                            }}
                            arcLinkLabelsOffset={2}
                            arcLinkLabelsColor={{ from: 'color' }}
                            arcLinkLabelsThickness={3}
                            arcLabelsComponent={( { datum, label, style } ) => (
                                <animated.g transform={style.transform} style={{ pointerEvents: 'none' }}>
                                    <circle fill={style.textColor} cy={6} r={13} />
                                    <circle fill="#ffffff" stroke={datum.color} strokeWidth={2} r={14} />
                                    <text
                                        textAnchor="middle"
                                        dominantBaseline="central"
                                        fill={style.textColor}
                                        style={{
                                            fontSize: 14,
                                            fontWeight: 800,
                                        }}
                                    >
                                        {label}
                                    </text>
                                </animated.g>
                            )}
                        // legends={[
                        //     {
                        //         anchor: "bottom",
                        //         direction: "row",
                        //         translateY: 56,
                        //         itemWidth: 70,
                        //         itemHeight: 18,
                        //         itemTextColor: "#999",
                        //         symbolSize: 18,
                        //         symbolShape: "circle",
                        //         effects: [
                        //             {
                        //                 on: "hover",
                        //                 style: {
                        //                     itemTextColor: "#000",
                        //                 },
                        //             },
                        //         ],
                        //     },
                        // ]}
                        />
                }
            </div>
        );
    }
}

export default Connect(ActiveFiresByStatusGraph);